import { render, staticRenderFns } from "./PartsUsedBarChart.vue?vue&type=template&id=2eaa51cc&"
import script from "./PartsUsedBarChart.vue?vue&type=script&lang=js&"
export * from "./PartsUsedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports